<template>
  <div class="wrap business-content">
            <h2 class="public-title">文都集团</h2>
            <el-row>
                <el-col :md="6" :sm="8" :xs="8" v-for="(item,index) in business" :key="index"> 
                    <p class="business-list">
                        <img :src='require("@/assets/images/icon/"+item.iconUrl)' alt="">
                        <span>{{item.name}}</span>
                    </p>
                </el-col>
            </el-row>
        </div>
</template>

<script >
import { defineComponent,ref ,reactive} from 'vue'
export default defineComponent({
 setup(){
     const business=reactive([
            {
                iconUrl:'ic_wdjy.png',
                name:'文都教育'
            },
            {
                iconUrl:'ic_wdzx.png',
                name:'文都教育在线'
            },
            // {
            //     iconUrl:'ic_wdyjl.png',
            //     name:'文都优加乐'
            // },
            // {
            //     iconUrl:'ic_wdykb.png',
            //     name:'文都优考帮'
            // },
            // {
            //     iconUrl:'ic_wdgkb.png',
            //     name:'文都高考帮'
            // },
            // {
            //     iconUrl:'ic_wdpy.png',
            //     name:'文都培优教育'
            // },
            {
                iconUrl:'ic_wdky.png',
                name:'文都考研'
            },
            {
                iconUrl:'ic_wdslj.png',
                name:'文都四六级'
            },
            {
                iconUrl:'ic_wdyfjxy.png',
                name:'文都鹰飞集训营'
            },
            // {
            //     iconUrl:'ic_wdyp.png',
            //     name:'文都语培'
            // },
            // {
            //     iconUrl:'ic_wdys.png',
            //     name:'文都雅思'
            // },
            // {
            //     iconUrl:'ic_wdtf.png',
            //     name:'文都托福'
            // },
            // {
            //     iconUrl:'ic_wdyx.png',
            //     name:'文都游学'
            // },
            {
                iconUrl:'ic_wdyk.png',
                name:'文都医考'
            },
            {
                iconUrl:'ic_wdgk.png',
                name:'文都公考'
            },
            {
                iconUrl:'ic_wdjszg.png',
                name:'文都教师资格'
            },
            {
                iconUrl:'ic_wdjk.png',
                name:'文都建考'
            },
            {
                iconUrl:'ic_wdfk.png',
                name:'文都法考'
            },
            {
                iconUrl:'ic_wdmx.png',
                name:'文都敏行'
            },
            {
                iconUrl:'ic_wdzl.png',
                name:'文都中律'
            },
            {
                iconUrl:'ic_wdbl.png',
                name:'文都比邻'
            },
            {
                iconUrl:'ic_wdfy.png',
                name:'文都飞扬'
            }

        ])
     return{
        business
     }
 }
})
</script>

<style lang="scss" scoped type="text/scss">
.business-content{
    padding-bottom:40px;
}
.business-list{
    height:32px;
    padding:40px 0;
    font-size:20px;
    color:#1B1D1F;
    line-height: 32px;
    font-weight: bold;
    img{
        float:left;
        width:32px;
        height:32px;
        margin-right:16px;
    }
}
</style>
